module.exports = __webpack_public_path__ + "static/img/kr.edf11a0f.png";